<template>
    <ContactUsPage :nav-bar-show-logo-text="false" form-type="advertisewithus">
        <h1 class="font-large text-blue-60 text-2xl lg:text-left lg:text-3xl">
            <span class="font-extrabold">Advertise With Us</span>
        </h1>
        <div class="text-grey-70">
            <p class="pb-2 pt-2 font-extrabold">Introduction to advertising your recruitment agency on Agency Central</p>
            <p class="pb-2 pt-2">
                On Agency Central, every agency is uniquely advertised by every job role they recruit for, allowing the
                <span class="font-bold">25,000+ Employers</span> and
                <span class="font-bold">425,000+ Candidates</span> that visit our site every month to find the agencies that best suit their needs.
            </p>
            <p class="pb-2 pt-2">Contact us either by phone or by using the form below, and find out more.</p>
            <div class="rounded-xl p-4 mb-4 bg-grey-20">
                <p>
                    <span class="font-bold">Welcome to Agency Central's Recruitment Advertising area, where we explain how advertising your recruitment agency with us, can generate targeted responses from both employers and candidates.</span>
                </p>
                <p class="pb-2 pt-2">
                    <span class="font-bold">Agency Central contains a unique directory, allowing employers and job seekers to find your recruitment agency in a more efficient way than ever before!</span>
                </p>
            </div>
            <p class="pb-2 pt-2 font-extrabold">If you are a recruitment agency and would like to find out more, you can...</p>

        </div>
    </ContactUsPage>
</template>

<script>
import InputButton from 'Components/InputButton.vue';
import IconChevronRight from 'Components/Icons/IconChevronRight';
import ContactUsPage from 'Components/layouts/ContactUsPage.vue';
import LayoutPage from 'Components/layouts/LayoutPage';
import NavBar from 'Components/NavBar/NavBar';
import InputText from 'Components/InputText.vue';

export default {
    name: 'AdvertiseWithUs',
    components: {
        ContactUsPage,
        InputButton,
        IconChevronRight,
        LayoutPage,
        NavBar,
        InputText,
    },
};
</script>
